import React from "react";
import { Download, X } from "lucide-react";

interface BarChartHeaderProps {
  title: string;
  mode?: "inline" | "expanded";
  onDownload?: () => void;
  onToggleExpand?: () => void;
}

export const BarChartHeader: React.FC<BarChartHeaderProps> = ({
  title,
  mode = "inline",
  onDownload,
  onToggleExpand,
}) => {
  return (
    <div
      className={`relative flex justify-center border-b border-border bg-card px-4 py-3 ${
        mode === "expanded" ? "rounded-t-2xl" : ""
      }`}
    >
      <h3 className="text-center text-base font-medium text-foreground">
        {title}
      </h3>
      {mode === "expanded" && (
        <div className="diagram-buttons absolute right-2 top-2 flex gap-1">
          {onDownload && (
            <button
              onClick={onDownload}
              className="inline-flex h-8 w-8 items-center justify-center text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground rounded-sm"
              aria-label="Download as PNG"
              title="Download as PNG"
            >
              <Download className="h-4 w-4" />
            </button>
          )}
          {onToggleExpand && (
            <button
              onClick={onToggleExpand}
              className="inline-flex h-8 w-8 items-center justify-center text-sm font-medium ring-offset-background transition-colors hover:bg-accent hover:text-accent-foreground rounded-sm"
              aria-label="Close"
              title="Close"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
